export default __webpack_public_path__ + "static/media/icon-vps.02f70121.svg";